import axios from "axios";
import * as API_LINKS from '../../config/links.jsx'
import {toast} from 'react-toastify'

export const FETCH_MAINTENANCE_CATEGORIES_TABLE = 'FETCH_MAINTENANCE_CATEGORIES_TABLE'
export const RECEIVE_MAINTENANCE_CATEGORIES_TABLE = 'RECEIVE_MAINTENANCE_CATEGORIES_TABLE'
export const FAILED_MAINTENANCE_CATEGORIES_TABLE = 'FAILED_MAINTENANCE_CATEGORIES_TABLE'

export const FETCH_MAINTENANCE_SUB_CATEGORY_TABLE = 'FETCH_MAINTENANCE_SUB_CATEGORY_TABLE'
export const RECEIVE_MAINTENANCE_SUB_CATEGORY_TABLE = 'RECEIVE_MAINTENANCE_SUB_CATEGORY_TABLE'
export const FAILED_MAINTENANCE_SUB_CATEGORY_TABLE = 'FAILED_MAINTENANCE_SUB_CATEGORY_TABLE'

export function fetchMaintenanceCategories(){    return (dispatch, getState) => {
        
            let {authStore} = getState();
            let auth = null;
            if(authStore.authData){
                auth = authStore.authData.result.token;
            }
        dispatch({type: FETCH_MAINTENANCE_CATEGORIES_TABLE});
        axios({
            method: 'post',
            url: API_LINKS.MAINTENANCE_CATEGORY_LIST,
            headers: {
                Authorization: auth
            }
        })
        .then((response) => {
            dispatch( {
                type: RECEIVE_MAINTENANCE_CATEGORIES_TABLE,
                payload: response.data
            })
        })
        .catch(function(error){
            if (error.response) {
                if(error.response.status === 401) {
                    dispatch({
                        type: FAILED_MAINTENANCE_CATEGORIES_TABLE
                    })
                    return toast.error("Invalid credentials! Please try again!");
                } else if (error.response.status === 404 || error.response.status === 500) {
                    dispatch({
                        type: FAILED_MAINTENANCE_CATEGORIES_TABLE
                    })
                    return toast.error("Server cannot be contacted! Please ask your system administrator!");
                } else if (error.response.status === 400) {
                    dispatch({
                        type: FAILED_MAINTENANCE_CATEGORIES_TABLE
                    })
                    return toast.error(error.response.data.message);
                } else {
                    dispatch({
                        type: FAILED_MAINTENANCE_CATEGORIES_TABLE
                    })
                    return toast.error('Something went wrong... Please try again later...');
                }
            } else if (error.request) {
                dispatch({
                    type: FAILED_MAINTENANCE_CATEGORIES_TABLE
                })
                return toast.error('Request error! Please try again later...')
            } else {
                dispatch({
                    type: FAILED_MAINTENANCE_CATEGORIES_TABLE
                })
                return toast.error('Something went wrong... Please try again later...')
            }
        })
    }
}

export function fetchMaintenanceSubCategories(){    return (dispatch, getState) => {
        
            let {authStore} = getState();
            let auth = null;
            if(authStore.authData){
                auth = authStore.authData.result.token;
            }
        dispatch({type: FETCH_MAINTENANCE_SUB_CATEGORY_TABLE});
        axios({
            method: 'post',
            url: API_LINKS.MAINTENANCE_SUB_CATEGORY_LIST,
            headers: {
                Authorization: auth
            }
        })
        .then((response) => {
            dispatch( {
                type: RECEIVE_MAINTENANCE_SUB_CATEGORY_TABLE,
                payload: response.data
            })
        })
        .catch(function(error){
            if (error.response) {
                if(error.response.status === 401) {
                    dispatch({
                        type: FAILED_MAINTENANCE_SUB_CATEGORY_TABLE
                    })
                    return toast.error("Invalid credentials! Please try again!");
                } else if (error.response.status === 404 || error.response.status === 500) {
                    dispatch({
                        type: FAILED_MAINTENANCE_SUB_CATEGORY_TABLE
                    })
                    return toast.error("Server cannot be contacted! Please ask your system administrator!");
                } else if (error.response.status === 400) {
                    dispatch({
                        type: FAILED_MAINTENANCE_SUB_CATEGORY_TABLE
                    })
                    return toast.error(error.response.data.message);
                } else {
                    dispatch({
                        type: FAILED_MAINTENANCE_SUB_CATEGORY_TABLE
                    })
                    return toast.error('Something went wrong... Please try again later...');
                }
            } else if (error.request) {
                dispatch({
                    type: FAILED_MAINTENANCE_SUB_CATEGORY_TABLE
                })
                return toast.error('Request error! Please try again later...')
            } else {
                dispatch({
                    type: FAILED_MAINTENANCE_SUB_CATEGORY_TABLE
                })
                return toast.error('Something went wrong... Please try again later...')
            }
        })
    }
}